export default __webpack_public_path__ + "static/media/banner104.8c0a0c21.jpg";